import { useHistory, useLocation } from 'react-router-dom'
import { userSelector, useUserStore } from 'store/userInfo.store'
// import useCore from './useCore'
export default function useAuth ({ redirect = true }) {
  const history = useHistory()
  const location = useLocation()
  // const { user } = useCore()
  const currentUser = useUserStore(userSelector)

  if (redirect) {
    // console.log("useAuth",currentUser)
    if (!location.pathname.startsWith('/login') && !Number(currentUser?.id >0) ) {
      history.push('/login')
    } else if (Number(currentUser?.id >0) && location.pathname.startsWith('/login')) {
      history.push('/home')
    }
  }
  return Number(currentUser?.id >0)
}
